export default "__VITE_ASSET__ZuomI5id__"